import { observer } from "mobx-react"
import React from "react"
import ModalStore from "../../Configs/Store/modals"
import CircleIcon from "../Common/CircleIcon"
import CloseButton from "../Common/CloseButton"
import "../../styles/Header/talkToExpertModal.less"
import GenericModal from "../Common/GenericModal"
import TalkToExpertModalJson from "../../Configs/JSON/talkToExpertModal.json"
import TextMultiStyle from "../Common/TextMultiStyle"
import AppStore from "../../Configs/Store/index"
import CommonStore from "../../Configs/Store/common"

const TalkToExpertModal = observer(() => {
  const handleclose = () => ModalStore.setTalk2Expert(false)
  const closeAllBenMobModal = () => {
    CommonStore.setmythBusterModal(false)
  }

  return (
    <GenericModal
      visibleState={ModalStore.header_Talk2Expert}
      updateVisibility={handleclose}
      // closeIcon={<CircleIcon iconUrl={`common/Path15589`} iconStyle="closeIconModalMob" onClick={null} />}
      rootClassAntCustom={"talkToExpertModal"}
      showButton={true}
      buttonWrapper={"calculateFormDiv"}
      buttononClick={handleclose}
      buttonStyle={"MainButton"}
      buttonText={TalkToExpertModalJson.buttonText}
      zIndex={3000}
      component={
        <div>
          <button className="CloseButton" data-dismiss="modal" aria-label="Close" onClick={handleclose}>
            {/* <span aria-hidden="true">&times;</span> */}
          </button>
          <div className="ContentWrap">
            <TextMultiStyle text={TalkToExpertModalJson.Title} StyleText="SectionTitle" />
            {TalkToExpertModalJson.content.map((x, i) => (
              <div key={i} className="subContentWrap">
                <div className="contentTitle">{x.title}</div>
                <a className="Number" href={x.NumberURL}>
                  {x.Number}
                </a>
                <div className="content" dangerouslySetInnerHTML={{ __html: x.Content }}></div>
              </div>
            ))}
          </div>
        </div>
      }
    />
  )
})

export default TalkToExpertModal
